// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__Oe9FQ","skeletonCell":"Skeleton_skeletonCell__g8e8H","gradient":"Skeleton_gradient__JOLXq"};